import { useContext } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AutoCompletePerson from "../../components/autocomplete/AutoCompletePerson";
import NavDropdown from "../../components/nav/NavDropdown";
import OpretPerson from "../../components/wizards/OpretPerson/OpretPerson";
import {
  // PersonFiltersContext,
  PersonFiltersEventContext,
} from "../../context/FiltersContext";
import {
  IPersonSearchFilterSetting,
  QueryFilter,
  PersonFilterKeys,
} from "../../interfaces/filters";
import { f } from "../../util/f";
import { PersonDtoFilterInput } from "../../interfaces/schema";
import { UserQueryContext } from "../../context/UserContext";
import AccessDenied from "../../components/AccessDenied";

export default function PersonLayout() {
  // navigation
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // context
  // const filters = useContext(PersonFiltersContext);
  const { user, hasPermission } = useContext(UserQueryContext);
  const updateFilters = useContext(PersonFiltersEventContext);

  if (!hasPermission(user, "BasisRead")) return <AccessDenied />;
  return (
    <>
      <meta name="theme-color" content="rgb(157, 0, 79)" />
      <div className="l-main">
        <header className="navbar">
          <NavDropdown />
          <AutoCompletePerson
            sizeLarge
            includeFirstItem={true}
            onSelectedItemChange={({ selectedItem, inputValue }) => {
              if (selectedItem) {
                if (selectedItem.id && selectedItem.id !== "first") {
                  navigate(`/person/${selectedItem.id}`, { replace: false });
                } else {
                  const inputs = inputValue?.split(" ");

                  const searchQueryFilter: QueryFilter<
                    PersonFilterKeys,
                    IPersonSearchFilterSetting
                  > = {
                    filterKey: "search",
                    parentFilter: "and",
                    filter: f<PersonDtoFilterInput>()
                      .addFilter(
                        "and",
                        inputs?.map((input) => {
                          return {
                            fuldtNavn: {
                              contains: input,
                            },
                          };
                        }),
                      )
                      .build(),
                    settings: {
                      query: `Navn indeholder: "${inputValue}"`,
                    },
                  };
                  updateFilters({
                    event: "update",
                    queryFilter: searchQueryFilter,
                  });

                  navigate(`/person`, {
                    replace: pathname === "/person",
                  });
                }
              }
            }}
          />
          {hasPermission(user, "BasisWrite") ? <OpretPerson /> : <div></div>}
        </header>
        <Outlet />
      </div>
    </>
  );
}
